// src/pages/Signup.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase/supabaseClient';

const Signup = () => {
  const [form, setForm] = useState({ username: '', name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const { username, name, email, password } = form;

    if (!username || !name || !email || !password) {
      setError('Por favor, preencha todos os campos');
      setLoading(false);
      return;
    }

    try {
      // 1. Criar usuário no Auth
      const { data: authData, error: authError } = await supabase.auth.signUp({
        email,
        password
      });

      if (authError) {
        setError(`Erro no Auth: ${authError.message}`);
        setLoading(false);
        return;
      }

      const authUserId = authData?.user?.id;

      if (!authUserId) {
        setError('Verifique seu e-mail para concluir o cadastro.');
        setLoading(false);
        return;
      }

      // 2. Inserir na tabela users (usar o mesmo ID do Auth)
      const { error: userError } = await supabase
        .from('users')
        .insert({
          id: authUserId,
          username,
          name,
          email,
          role: 'basic', // ou outro valor inicial
          created_at: new Date().toISOString()
        });

      if (userError) {
        setError(`Erro ao inserir usuário: ${userError.message}`);
        setLoading(false);
        return;
      }

      navigate('/login');
    } catch (err) {
      console.error(err);
      setError('Erro inesperado ao criar conta');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-md w-full p-8 bg-white rounded shadow-md">
        <h2 className="text-2xl font-bold mb-6 text-center">Criar Conta</h2>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-600 rounded">
            {error}
          </div>
        )}

        <form onSubmit={handleSignup}>
          {['username', 'name', 'email', 'password'].map((field) => (
            <div key={field} className="mb-4">
              <label htmlFor={field} className="block text-gray-700 font-semibold mb-2 capitalize">
                {field === 'name' ? 'Nome completo' : field === 'username' ? 'Usuário' : field}
              </label>
              <input
                id={field}
                name={field}
                type={field === 'password' ? 'password' : 'text'}
                placeholder={field === 'email' ? 'seu@email.com' : ''}
                className="w-full px-3 py-2 border border-gray-300 rounded"
                value={form[field]}
                onChange={handleChange}
                disabled={loading}
              />
            </div>
          ))}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition-colors font-semibold disabled:opacity-50"
          >
            {loading ? 'Criando...' : 'Criar conta'}
          </button>
        </form>

        <p className="text-center mt-4 text-sm text-gray-600">
          Já tem conta?{' '}
          <a href="/login" className="text-blue-600 hover:underline">
            Fazer login
          </a>
        </p>
      </div>
    </div>
  );
};

export default Signup;

